'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = void 0;
const $ = require("jquery");
class Tab {
    constructor() {
        // 各記事にタブ切り替え番号の付与
        this.addSpecialTabNumber();
        // タブの生成
        this.createSpecialTab();
        // タブの切替
        this.switchSpecialTab();
    }
    addSpecialTabNumber() {
        // 各記事にタブ切り替え番号の付与
        const articleCount = Number($('.paramSpecialArticle').length);
        let tabNumber = 0;
        for (let i = 0; i < articleCount; i++) {
            if (i % 12 === 0) {
                tabNumber++;
            }
            $('.bulletSpecialArticle').eq(i).attr('data-tab-number', tabNumber);
        }
        // 1つ目のタブの要素以外非表示
        this.hideSpecialContent();
    }
    hideSpecialContent() {
        $('.bulletSpecialArticle').not(`[data-tab-number="1"]`).hide();
    }
    // タブの生成
    createSpecialTab() {
        const articleCount = Number($('.paramSpecialArticle').length);
        const articleBlock = Math.ceil(articleCount / 12);
        let body = '';
        let min = 0;
        let max = 0;
        let isActive = 'true';
        for (let i = 1; i <= articleBlock; i++) {
            // 1の場合
            if (i === 1) {
                min = i;
            }
            else {
                min = (i - 1) * 12 + 1;
                isActive = 'false';
            }
            // MAX計算
            max = i * 12;
            if (max > articleCount) {
                max = articleCount;
            }
            let minHtml = ('00' + min).slice(-2);
            let maxHtml = '';
            if (min !== max) {
                maxHtml = `～${this.zeroPadding(max, 2)}`;
            }
            body += `<li class="trigSpecialTab" data-tab-number="${i}" data-is-active="${isActive}">${minHtml}${maxHtml}</li>`;
        }
        $('.bulletSpecialTab').html(body);
    }
    // タブでの切り替え
    switchSpecialTab() {
        $('.trigSpecialTab').on('click', (e) => {
            $('.trigSpecialTab').attr('data-is-active', 'false');
            $(e.currentTarget).attr('data-is-active', 'true');
            const tabNumber = Number($(e.currentTarget).attr('data-tab-number'));
            $('.bulletSpecialArticle').hide();
            $(`.bulletSpecialArticle[data-tab-number="${tabNumber}"]`).fadeIn('slow');
        });
    }
    zeroPadding(number, length) {
        return (Array(length).join('0') + number).slice(-length);
    }
}
exports.Tab = Tab;
exports.default = Tab;
